import { FC, useEffect } from "react";

export interface NativeShareDialogProps {
  open: boolean;
  onClose?: () => void;
  sharedLink: string
  title?: string
  text?: string
}

const NativeShareDialog: FC<NativeShareDialogProps> = ({sharedLink, text, title, open}) => {
  const handleShare = async () => {
    if(navigator.share) {
      try{
        await navigator.share({
          title: title,
          text: text,
          url: sharedLink
        })
      }catch (error){
        console.error(error)
      }
    }
  }
  useEffect(() => {
    if(open) {
      handleShare()
    }
  }, [open]);
  return null;
}
export default NativeShareDialog